module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074f9_logo_200x200.489d099b.png";